import { FormTypography } from "@/forms-design-system/FormTypography";
import { useTranslate } from "@/hooks/useTranslate";

export interface ThemedRemainingItemsInfoProps {
  remainingItemCount: number;
}

export const ThemedRemainingItemsInfo = ({ remainingItemCount }: ThemedRemainingItemsInfoProps) => {
  const { t } = useTranslate();

  return (
    <FormTypography variant="body2" vibe="brand" alignContent="center">
      {t("ticketing", "rate.xLeft", {
        count: remainingItemCount,
      })}
    </FormTypography>
  );
};
